import { useCallback, useEffect, useState } from 'react'

import { logger } from '@/lib/default-logger'

const STORAGE_KEY = 'sidebar-collapsed'

export function useSidebarCollapsed(): [boolean, () => void] {
	const [collapsed, setCollapsed] = useState<boolean>(() => {
		try {
			return localStorage.getItem(STORAGE_KEY) === 'true'
		} catch (error) {
			logger.error('Error reading sidebar state from localStorage:', error)
			return false
		}
	})

	useEffect(() => {
		try {
			localStorage.setItem(STORAGE_KEY, String(collapsed))
		} catch (error) {
			logger.error('Error saving sidebar state to localStorage:', error)
		}
	}, [collapsed])

	const toggle = useCallback(() => {
		setCollapsed((prev) => !prev)
	}, [])

	return [collapsed, toggle]
}
